import { themeAtom } from "Infrastructure/Theme/Atom/themeAtom";
import { ListSubheader, styled, type Theme } from "@mui/material";
import { useAtom } from "jotai";

type NavGroup = {
	navlabel?: boolean;
	subheader?: string;
};

interface ItemType {
	item: NavGroup;
}

const StyledListSubheader = styled(ListSubheader)(
	({ theme }: { theme: Theme }) => ({
		...theme.typography.overline,
		fontWeight: "700",
		marginTop: theme.spacing(3),
		marginBottom: theme.spacing(0),
		color: theme.palette.text.primary,
		lineHeight: "26px",
	}),
);

export const NavGroup = ({ item }: ItemType) => {
	const [themeConfiguration] = useAtom(themeAtom);
	const { isCollapse, isSidebarHover } = themeConfiguration;
	const shouldShowDots = isCollapse && !isSidebarHover;

	return (
		<StyledListSubheader disableSticky>
			{shouldShowDots ? null : item?.subheader}
		</StyledListSubheader>
	);
};
